export const actions = {
  FETCH_USERBOARD_DATA: 'FETCH_USERBOARD_DATA',
  SAVE_USERBOARD_DATA: 'SAVE_USERBOARD_DATA',
  FETCH_TEAM_USERS_DATA: 'FETCH_TEAM_USERS_DATA',
  SAVE_TEAM_USERS_DATA: 'SAVE_TEAM_USERS_DATA',
  GET_USERBOARD_FILTERED_OBJECTIVES: 'GET_USERBOARD_FILTERED_OBJECTIVES',
  SEND_REMINDERS_REQUEST: 'SEND_REMINDERS_REQUEST',
  INCREASE_LOADING_COUNT: 'INCREASE_LOADING_COUNT',
  DECREASE_LOADING_COUNT: 'DECREASE_LOADING_COUNT',
  FETCH_DEPARTMENT_DATA: 'FETCH_DEPARTMENT_DATA',
  SAVE_DEPARTMENT_DATA: 'SAVE_DEPARTMENT_DATA',
  FETCH_USERBOARD_USERS_DATA: 'FETCH_USERBOARD_USERS_DATA'
};

export const fetchUserboardData = requestBody => ({
  type: actions.FETCH_USERBOARD_DATA,
  requestBody
});

export const saveUserboardData = data => ({
  type: actions.SAVE_USERBOARD_DATA,
  data
});

export const fetchTeamUsersData = requestBody => ({
  type: actions.FETCH_TEAM_USERS_DATA,
  requestBody
});

export const saveTeamUsersData = data => ({
  type: actions.SAVE_TEAM_USERS_DATA,
  data
});

export const getUserBoardFilteredObjectives = requestBody => ({
  type: actions.GET_USERBOARD_FILTERED_OBJECTIVES,
  requestBody
});

export const sendRemindersRequest = requestBody => ({
  type: actions.SEND_REMINDERS_REQUEST,
  requestBody
});

export const fetchDepartmentUsersData = requestBody => ({
  type: actions.FETCH_DEPARTMENT_DATA,
  requestBody
});

export const increaseLoadingCount = () => ({
  type: actions.INCREASE_LOADING_COUNT
});

export const decreaseLoadingCount = () => ({
  type: actions.DECREASE_LOADING_COUNT
});
